import React, { useEffect, useRef, useState } from 'react';
import useGoBackOrGoHome from './redirects/useGoBackOrGoHome';
import { SuspenseWrapper } from './SuspenseWrapper';
import { getCookieConsentData } from '../consent/getCookieConsentData';
import { useAppFeaturesContext } from '../contexts/AppFeaturesContext/AppFeaturesContext';
import { CookieConsentData } from '../consent/types';

const ConsentRoute: React.FC = () => {
  const goBackOrGoHomeRef = useRef(useGoBackOrGoHome());
  const { languageCode } = useAppFeaturesContext();

  const [data, setData] = useState<CookieConsentData | null>(null);
  const [waitTarget, setWaitTarget] = React.useState<
    Promise<void> | undefined
  >();

  useEffect(() => {
    setWaitTarget(
      getCookieConsentData(languageCode, goBackOrGoHomeRef.current).then(data =>
        setData(data)
      )
    );
  }, [languageCode]);

  return (
    <SuspenseWrapper promiseToWait={waitTarget}>
      <AuthRequired>
        {data && (
          <ConsentComponent
            uiElementOptions={data.uiElementOptions}
            info={data.info}
            consents={data.consents}
          />
        )}
      </AuthRequired>
    </SuspenseWrapper>
  );
};

const ConsentComponent = React.lazy(
  () => import('../CookieConsent/CookieConsent')
);
const AuthRequired = React.lazy(() => import('./redirects/AuthRedirect'));

export default ConsentRoute;
